import { PropTypes } from 'prop-types';
import moment from 'moment';
import React from 'react';
import { FilterPlacement, PageFilters } from '../../../core/components/PageFilters';
import TabsWithContent from '../../../core/components/TabsWithContent';
import DateBasedReadings from './DateBasedReadings';
import DetergentBasedReadings from './DetergentBasedReadings';

const toFilterDate = (value) => {
  if (!value) return null;
  const date = moment(value);
  return date.isValid() ? date.toDate() : null;
};

export const HistoricalTankReadings = ({ asOfDateProps, ...props }) => {
  const filterConfigs = [
    {
      id: 'historicalTankReadingsDateRange',
      type: 'dateRange',
      name: 'Date',
      placement: FilterPlacement.Chiclet,
      defaultVisible: true,
      icon: <i className="uil uil-calendar-alt" />,
      startDate: toFilterDate(asOfDateProps.fromDate),
      endDate: toFilterDate(asOfDateProps.untilDate),
      native: true,
      onChange: ([startDate, endDate]) => {
        asOfDateProps.setFromDate(startDate ? moment(startDate) : asOfDateProps.fromDate);
        asOfDateProps.setUntilDate(endDate ? moment(endDate) : asOfDateProps.untilDate);
      },
    },
  ];

  const getTabComponents = () => ({
    dateBased: <DateBasedReadings {...props} />,
    detergentBased: <DetergentBasedReadings {...props} />,
  });

  return (
    <React.Fragment>
      <div className="filters-actions-container">
        <PageFilters filters={filterConfigs} maxChicletFilters={1} />
      </div>
      <div className="content-container mt-3">
        <TabsWithContent
          tabHeaders={Object.keys(getTabComponents())}
          components={getTabComponents()}
          classes="detergent-override"
        />
      </div>
    </React.Fragment>
  );
};

HistoricalTankReadings.propTypes = {
  asOfDateProps: PropTypes.shape({}).isRequired,
};

export default HistoricalTankReadings;
